import { ProxyServiceInfoDc, QueryLayerServiceInfoDc } from "@evergis/api";
import { createAction, createReducer } from "redux-act";
import produce from "immer";

import { reducerRegistry } from "../reducerRegistry";

export const reducerName = "tempSourceLayers";

export type TempSourceLayersItem = (QueryLayerServiceInfoDc | ProxyServiceInfoDc) & {
  isVisible?: boolean;
  opacity?: number;
};

export type TempSourceLayersState = {
  layers: TempSourceLayersItem[];
};

const initialState: TempSourceLayersState = {
  layers: [],
};

export const setTempSourceLayers = createAction<TempSourceLayersItem[]>("tempSourceLayers/setTempSourceLayers");
export const addTempSourceLayer = createAction<TempSourceLayersItem>("tempSourceLayers/addTempSourceLayer");
export const deleteTempSourceLayer = createAction<string>("tempSourceLayers/deleteTempSourceLayer");
export const changeTempSourceLayerVisibility = createAction<string>("tempSourceLayers/changeTempSourceLayerVisibility");
export const changeTempSourceLayerOpacity = createAction<{ layerName: string; opacity: number }>(
  "tempSourceLayers/changeTempSourceLayerOpacity",
);

export const reducer = createReducer({}, initialState);

reducer.on(
  setTempSourceLayers,
  produce((state: TempSourceLayersState, layers) => {
    state.layers = layers;
  }),
);

reducer.on(
  addTempSourceLayer,
  produce((state: TempSourceLayersState, layer) => {
    state.layers = [...state.layers, { ...layer, isVisible: true, opacity: 1 }];
  }),
);

reducer.on(
  deleteTempSourceLayer,
  produce((state: TempSourceLayersState, layerName) => {
    state.layers = state.layers.filter(({ name }) => name !== layerName);
  }),
);

reducer.on(
  changeTempSourceLayerVisibility,
  produce((state: TempSourceLayersState, layerName) => {
    state.layers = state.layers.map(layer =>
      layer.name === layerName ? { ...layer, isVisible: !layer.isVisible } : layer,
    );
  }),
);

reducer.on(
  changeTempSourceLayerOpacity,
  produce((state: TempSourceLayersState, { layerName, opacity }) => {
    state.layers = state.layers.map(layer => (layer.name === layerName ? { ...layer, opacity } : layer));
  }),
);

reducerRegistry.register(reducerName, reducer);
